// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ulHj","buttons":"styles_buttons__1S2fL"};